import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { getSchools } from "../lib/api";
import SchoolDetailModal from "./SchoolDetailModal";

const LVL = { High: "badge-critical", severe: "badge-critical", moderate: "badge-watch", normal: "badge-normal" };
const LVL_LABEL = { severe: "Severe Impact", moderate: "Moderate Impact", normal: "Low Impact" };
const TREND = { improving: { g: "▲", c: "up", t: "Improving" }, stable: { g: "▬", c: "flat", t: "Stable" }, worsening: { g: "▼", c: "down", t: "Worsening" } };

const SchoolMobilityPanel = ({ weather }) => {
  const { data } = useQuery({ queryKey: ["schools"], queryFn: getSchools, refetchInterval: 60000 });
  const [sel, setSel] = useState(null);
  if (!data) return null;
  const c = data.counts || { normal: 0, moderate: 0, severe: 0 };

  return (
    <div className="panel entrance" data-testid="school-mobility-panel">
      <div className="panel-head">
        <div className="panel-title">
          <div className="p-ic" style={{ background: "linear-gradient(135deg,#7a5b0b,#e0a300)" }}>
            <i className="fa-solid fa-school" />
          </div>
          School Mobility Intelligence
        </div>
        <span className="pill neutral" data-testid="schools-monitored">{data.monitored} monitored</span>
      </div>

      <div className="sm-counts" data-testid="school-counts">
        <div className="sm-count"><b className="c-normal">{c.normal}</b><span>Normal</span></div>
        <div className="sm-count"><b className="c-mod">{c.moderate}</b><span>Moderate</span></div>
        <div className="sm-count"><b className="c-sev">{c.severe}</b><span>Severe</span></div>
      </div>

      <div className="sm-peaks">
        <div className="sm-peak"><i className="fa-solid fa-sun" /> Morning Peak<b>{data.morning_peak}</b></div>
        <div className="sm-peak"><i className="fa-solid fa-cloud-sun" /> Afternoon Peak<b>{data.afternoon_peak}</b></div>
      </div>

      <div className="rr-sub" style={{ margin: "12px 0 8px" }}><i className="fa-solid fa-ranking-star" /> Highest-impact schools</div>
      <div className="sm-list" data-testid="school-top-list">
        {(data.top || []).slice(0, 5).map((s) => {
          const tr = TREND[s.trend] || TREND.stable;
          return (
            <button key={s.id} className="sm-item" data-testid={`school-${s.id}`} onClick={() => setSel(s)}>
              <div className="sm-item-main">
                <span className="sm-name">{s.name}</span>
                <span className={`badge ${LVL[s.level]}`}>{LVL_LABEL[s.level]}</span>
              </div>
              <div className="sm-item-sub">
                <span className="sm-delay">+{s.added_delay_min} min</span>
                <span className="sm-corr">{s.corridor}</span>
                <span className={`trend-ind ${tr.c} sm-trend`}><span className="trend-glyph">{tr.g}</span> {tr.t}</span>
              </div>
            </button>
          );
        })}
      </div>

      <div className="sm-rec" data-testid="school-ai-rec">
        <div className="sm-rec-head"><i className="fa-solid fa-robot" /> AI Recommendation
          {typeof data.confidence === "number" && <span className="conf-chip">Confidence: {data.confidence}%</span>}
        </div>
        <div className="sm-rec-body">{data.recommendation}</div>
      </div>

      {sel && <SchoolDetailModal school={sel} weather={weather} onClose={() => setSel(null)} />}
    </div>
  );
};

export default SchoolMobilityPanel;
